// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/tags_with_replied_to_sms" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementTagsWithRepliedToSms } from "./constants";
import type { EngagementTagsWithRepliedToSmsResult } from "./types";

export const getEngagementTagsWithRepliedToSms = reactQueryFetcherAdapter(
  engagementTagsWithRepliedToSms,
  (
    signal: AbortSignal,
    appGroupId: string,
    query: string,
    limit: number,
    filterKey?: string
  ): Promise<EngagementTagsWithRepliedToSmsResult> => {
    return fetch(
      "/engagement/tags_with_replied_to_sms",
      "GET",
      { app_group_id: appGroupId, query, limit, filter_key: filterKey },
      { signal }
    );
  }
);
